import React from 'react';
import { withRouter } from 'react-router-dom';
import memoize from 'memoize-one';

import { BasicActionBtns, ComponentDataTable } from '../../../components';
import { useDestroyOne } from '../../../hooks';

import { deleteAdminAdvisorRequest } from '../../../requests/admin/adminAdvisors';

const routes = {
  chacabuco: 'Puerto Chacabuco',
  natales: 'Puerto Natales'
};

const columns = memoize(
  ({
    handleBasicActions,
    modelUrl,
    withShow = false,
    withEdit = false,
    withDestroy = false,
    showClick = false,
    editClick = false
  }) => [
    {
      name: 'Nombre',
      selector: () => 'name',
      sortable: true,
      cell: ({ name }) => name,
      grow: '1.5'
    },
    {
      name: 'Email',
      selector: () => 'email',
      sortable: true,
      cell: ({ email }) => email,
      grow: '1.5'
    },
    {
      name: 'Teléfono',
      selector: () => 'phone',
      sortable: true,
      cell: ({ phone }) => phone,
      grow: '1'
    },
    {
      name: 'Ruta',
      selector: () => 'route',
      sortable: true,
      cell: ({ route }) => routes[route],
      grow: '1'
    },
    {
      cell: item => (
        <BasicActionBtns
          item={item}
          clickHandler={handleBasicActions}
          path={modelUrl}
          withShow={withShow}
          withEdit={withEdit}
          withDestroy={withDestroy}
          showClick={showClick}
          editClick={editClick}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: false,
      button: true,
      grow: '1',
      minWidth: '150px'
    }
  ]
);

const AdvisorsDataTable = ({
  tableData,
  tableDataAmount,
  isFetching,
  moreData,
  setMoreData,
  modelUrl,
  handleIndexRequest
}) => {
  const { handleShowModal, OnDestroyModalComponent } = useDestroyOne({
    setMoreData,
    deleteOneRequest: deleteAdminAdvisorRequest,
    onDeleteMessage: 'Asesor eliminado exitosamente',
    confirmationText: '¿Estás seguro de eliminar este asesor?',
    modalTitle: 'Eliminar Asesor'
  });

  const handleBasicActions = (item, action) => {
    switch (action) {
      case 'destroy':
        handleShowModal(item);
        break;
      default:
        alert('Error: Action not found');
    }
  };

  const sortColumnCase = name => {
    // Just for example of how to handle special sorts
    switch (name) {
      case 'caption':
        // sort_by_something = name of the scope in your model
        // return { sort_by_something: name };
        return { sort_column: name };
      default:
        return { sort_column: name };
    }
  };

  return (
    <>
      <ComponentDataTable
        onRequest={isFetching}
        columns={columns({
          handleBasicActions,
          modelUrl,
          withShow: false,
          withEdit: true,
          withDestroy: true
        })}
        handleSortCase={sortColumnCase}
        data={tableData}
        totalRows={tableDataAmount}
        moreData={moreData}
        resourceRequest={handleIndexRequest}
        RowsPage={10}
      />
      <OnDestroyModalComponent />
    </>
  );
};

export default withRouter(AdvisorsDataTable);
